<template>
  <MasterdataTableContainer
    :loading="$apollo.loading"
    :headers="headers"
    :table-data="tableData"
    :sort-by="sortBy"
    :actions="actions"
    :refetch="refetch"
    :components="components"
  />
</template>

<script>
import gql from 'graphql-tag'
import MasterdataTableContainer from '@/modules/masterdata/components/MasterdataTableContainer'
import MasterdataReasonsCreateModal from './MasterdataReasonsCreateModal'
import MasterdataReasonsEditModal from './MasterdataReasonsEditModal'
import MasterdataReasonsDeleteModal from './MasterdataReasonsDeleteModal'

export default {
  name: 'MasterdataReasons',

  components: {
    MasterdataTableContainer
  },

  data() {
    return {
      components: {
        createModal: {
          component: MasterdataReasonsCreateModal,
          title: 'Skapa orsak'
        }
      },
      actions: [
        {
          title: 'Redigera',
          icon: 'mdi-pencil',
          component: MasterdataReasonsEditModal,
          type: 'edit'
        },
        {
          title: 'Ta bort',
          icon: 'mdi-delete',
          component: MasterdataReasonsDeleteModal,
          type: 'delete'
        }
      ],
      sortBy: 'updated',
      headers: [
        {
          text: 'Orsak',
          value: 'name'
        },
        {
          text: '',
          value: 'actions',
          sortable: false,
          filterable: false,
          align: 'right'
        }
      ]
    }
  },

  apollo: {
    reasons: {
      query: gql`
        query reasons {
          reasons {
            uuid
            created
            created_by
            updated
            updated_by
            name
          }
        }
      `
    }
  },

  methods: {
    refetch() {
      this.$apollo.queries.reasons.refetch()
    }
  },

  computed: {
    tableData() {
      return this.reasons || []
    }
  }
}
</script>
